export const getDeploymentEnv = () => 'demo'
